import React from 'react'
import { Offer } from 'src/common/types/models/Offer'
import Modal, { ModalProps } from 'src/common/ui-kit/Modal'
import EditOfferForm from './EditOfferForm'

interface EditOfferModalProps extends ModalProps {
  offer: Offer | null
  onSuccessfulEdit?: () => void
}

const EditOfferModal: React.FC<EditOfferModalProps> = ({
  onClose,
  offer,
  onSuccessfulEdit,
  ...rest
}) => {
  return (
    <Modal className='py-5 px-5' onClose={onClose} {...rest}>
      <h2 className='modal-title'>Edit offer</h2>
      {offer && (
        <EditOfferForm
          offer={offer}
          onClose={onClose}
          onSuccessfulEdit={onSuccessfulEdit}
        />
      )}
    </Modal>
  )
}

export default EditOfferModal
